module.exports = __webpack_public_path__ + "img/mirapolis.13c8bce3.png";